import { useEffect, useState } from "react";
import { getSummaryTable, getSummaryTableByTournament } from "../../../api/transport/statsTransport";
//import { Loader } from "../../../components/Loader";
import { TournamentTableMini } from "../../../components/TournamentTable/TableMini";
import { SummaryTableDto } from "../../../types/stats/summaryTables";
import { Link } from "react-router";

interface SummaryTableMiniWidgetProps {
    summaryTableId?: number;
    tournamentLegacyId?: number;
}

export const SummaryTableMiniWidget: React.FC<SummaryTableMiniWidgetProps> = ({
    summaryTableId,
    tournamentLegacyId,
}) => {
    const [summaryTable, setSummaryTable] = useState<SummaryTableDto>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (tournamentLegacyId) {
            getSummaryTableByTournament(tournamentLegacyId).then(data => {
                if (!data) {
                    return Promise.reject();
                }

                setSummaryTable(data);
            }).finally(() => {
                setLoading(false);
            })
        } else if (summaryTableId) {
            getSummaryTable(summaryTableId).then((data) => {
                if (!data) {
                    return Promise.reject();
                }

                setSummaryTable(data);
            }).finally(() => {
                setLoading(false)
            });
        } else {
            setLoading(false);
        }
    }, [summaryTableId, tournamentLegacyId]);

    if (loading) {
        return null;
    }

    if (!summaryTable?.tableData?.length) {
        return null;
    }

    return (
        <div className="relative min-w-[200px]">
            <div className="transiton-all rounded-xl cursor-pointer hover:shadow-md overflow-hidden border border-gray-50" style={{ fontFamily: 'Futura, sans-serif' }}>
                <Link to={`/tables/?shows=${summaryTable.id}`} title={"Перейти к " + summaryTable.name} className="text-sky-950 hover:no-underline">
                    <div className="absolute -top-9 w-full flex flex-row justify-between items-center">
                        <span className="text-sky-950 font-xl font-semibold text-left uppercase italic">
                            Общий зачёт
                        </span>
                        <Link
                            to={`/tables/?shows=${summaryTableId}`}
                            className="self-end text-center flex items-center justify-center transition-all bg-slate-200 px-3 py-1 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm"
                        >
                            Перейти
                        </Link>
                    </div>
                    <TournamentTableMini
                        data={summaryTable?.tableData || []}
                        columns={['points']}
                        noLogos
                        rowClass="!h-10 !text-lg"
                    />
                </Link>
            </div>
        </div>
    );
}
